var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AirspaceTable',{on:{"hedgehop":_vm.airway_hedgehop,"handleShow":_vm.airspace_handle_show,"handleHide":_vm.airspace_handle_hide}})}
var staticRenderFns = []

export { render, staticRenderFns }